/**
 * JS Functions Related to Flash Messaging
 */

$(document).ready(function() {
  $('.flash-message__close').click( function() {
    $(this).parent().fadeOut(100);
  });
});